import { useState } from "react";
// import { useNavigate } from "react-router";
import TransparencyScore from "./TransparencyScore";
import AttributePage from "./Attribute";
import Packaging from "./Packaging";
import AnimalWelfare from "./AnimalWelfare";
import ClimateChange from "./ClimateChange";
// import Archive from "./Archive/ArchiveDefault";
import BreadCrumbs from "./BreadCrumbs";
import { COLUMNTITLES } from "../../utils/Enum";
import AdminTabs from "../../interfaces/AdminTabs";

const styles = {
  tabButton: (isActive: boolean, isDisabled: boolean) =>
    `bg-none border-none cursor-pointer mt-[8px] inline-flex px-4 py-2 rounded-t-lg whitespace-nowrap transition-colors duration-200 ${
      isActive ? "bg-white" : "bg-gray-400"
    } ${isDisabled ? "bg-gray-400/25 text-opacity-50" : ""}
    h-[40px] text-[14px] font-medium leading-normal`,
  archiveButton:
    "float-right mr-[20px] mb-[16px] px-[16px] py-[6px] rounded-sm border-2 border-blue text-blue whitespace-nowrap text-[14px] font-medium leading-normal",
};

const adminTabs: AdminTabs[] = [
  {
    label: COLUMNTITLES.OVERALL,
    content: <AttributePage category="overall" />,
  },
  { label: COLUMNTITLES.TRANSPARENCY, content: <TransparencyScore /> },
  {
    label: COLUMNTITLES.ENVIRONMENT,
    content: <AttributePage category="environmental" />,
  },
  {
    label: COLUMNTITLES.HUMANRIGHTS,
    content: <AttributePage category="humanrights" />,
  },
  { label: COLUMNTITLES.PACKAGING, content: <Packaging />, disabled: true },
  {
    label: COLUMNTITLES.ANIMALWELFARE,
    content: <AnimalWelfare />,
    disabled: true,
  },
  {
    label: COLUMNTITLES.CLIMATECHANGE,
    content: <ClimateChange />,
    disabled: true,
  },
];

// const archiveTab = { label: COLUMNTITLES.VIEWARCHIVE, content: <Archive /> };

const AdminDefaultLayout = ({ className }: { className?: string }) => {
  const [activeTab, setActiveTab] = useState(0);
  // const navigate = useNavigate();
  // const handleArchiveClick = () => {
  //   navigate("./archive");
  // };
  const handleTabClick = (index: number, disabled?: boolean) => {
    if (!disabled) setActiveTab(index);
  };

  return (
    <div className={`flex flex-col min-h-screen ${className}`}>
      <div className="bg-gray-200">
        <BreadCrumbs />
        <h1
          id="adminTitle"
          className="p-2 text-gray-900 text-center text-3xl font-medium drop-shadow-sm leading-[40px] my-5"
        >
          Admin Portal
        </h1>
        <div className="flex justify-between">
          <div className="flex mt-1 ml-10">
            {adminTabs.map((tab, index) => (
              <button
                key={index}
                id={tab.label}
                className={styles.tabButton(
                  activeTab === index,
                  !!tab.disabled,
                )}
                onClick={() => handleTabClick(index, tab.disabled)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          {/* Uncomment to enable the archive tab */}
          {/* <button
            id={archiveTab.label}
            className={styles.archiveButton}
            onClick={handleArchiveClick}
          >
            {archiveTab.label}
          </button> */}
        </div>
      </div>
      <div className="bg-white grow-5" id={adminTabs[activeTab].label}>
        {adminTabs[activeTab].content}
      </div>
    </div>
  );
};

export default AdminDefaultLayout;
